export default class ArrayHelper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static removeElementByValue (array: any[], item: any) {
    const index = array.indexOf(item);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
}
